import React, { useState } from "react";
import Input from "./Input";
import { motion } from "framer-motion";
import { leftContent } from "../data/anim";
import { signup } from "../actions/userActions";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
const Signup = ({ setLogin, errors, handleChange, handleSubmit }) => {
  console.log(errors);
  return (
    <motion.form
      variants={leftContent}
      initial="hidden"
      animate="visible"
      exit="exit"
      onSubmit={handleSubmit}
    >
      <Input
        type="text"
        id="firstname"
        name="firstname"
        direction="column"
        errorHandler="true"
        handleChange={handleChange}
        placeholder={errors.firstname}
      />
      <Input
        type="text"
        id="lastname"
        name="lastname"
        direction="column"
        errorHandler="true"
        handleChange={handleChange}
        placeholder={errors.lastname}
      />
      <Input
        type="email"
        id="email"
        name="email"
        direction="column"
        errorHandler="true"
        handleChange={handleChange}
        placeholder={errors.email}
      />
      <Input
        type="password"
        id="password"
        name="password"
        direction="column"
        errorHandler="true"
        handleChange={handleChange}
        placeholder={errors.password}
      />
      <button className="authBtn" type="submit">
        Sign up
      </button>
      <p>
        Already have an account?{" "}
        <span onClick={() => setLogin(true)}>Sign in</span>
      </p>
    </motion.form>
  );
};

export default Signup;
